export const ADD_CLICK_TRACKING_KEY = 'dm_modal_add_click';
export const REMOVE_CLICK_TRACKING_KEY = 'dm_modal_remove_click';
